import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import { useTranslation } from "react-i18next";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const defaultCenter = {
  lat: 25.2048,
  lng: 55.2708,
};

const libraries = ["places"];

const MapPickerModal = ({ show, onClose, onSelect }) => {
  const { t } = useTranslation();
  const [map, setMap] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [position, setPosition] = useState(null);
  const [address, setAddress] = useState("");

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setPosition({ lat, lng });

    onSelect({
      lat,
      lng,
      address,
    });

    onClose();
  };

  const handlePlaceChanged = () => {
    if (!autocomplete || !map) return;

    const place = autocomplete.getPlace();
    const location = place?.geometry?.location;

    if (!location) return;

    const lat = location.lat();
    const lng = location.lng();
    const formattedAddress = place.formatted_address || "";

    setPosition({ lat, lng });
    setAddress(formattedAddress);

    map.panTo({ lat, lng });
    map.setZoom(15);
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("Select Location")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
          libraries={libraries}
        >
          <Autocomplete
            onLoad={(auto) => setAutocomplete(auto)}
            onPlaceChanged={handlePlaceChanged}
            options={{
              fields: ["formatted_address", "geometry"],
            }}
          >
            <input
              type="text"
              placeholder="Search country, city, or address"
              className="form-control mb-3"
            />
          </Autocomplete>

          <GoogleMap
            mapContainerStyle={containerStyle}
            center={position || defaultCenter}
            zoom={12}
            onLoad={(mapInstance) => setMap(mapInstance)}
            onClick={handleMapClick}
          >
            {position && <Marker position={position} />}
          </GoogleMap>

          {address && (
            <div className="mt-2 text-muted small">
              <strong>{t("Selected Address:")}</strong> {address}
            </div>
          )}
        </LoadScript>
      </Modal.Body>
    </Modal>
  );
};

export default MapPickerModal;
